import React, { Component, Fragment } from "react";
import MenuDetail from "../MenuDetail";
import BiodataMenu from "./BiodataMenu";
import CollapseMenu from '../../../../config/atoms/CollapseMenu';
import { optionKebutuhan_1, optionKebutuhan_2 } from "./bioAsset/stateBox";
import swal from 'sweetalert';
import { Link } from "react-router-dom";
import $ from 'jquery';
import { biodataMahasiswa, biodataDropdown } from '../../../../dummy-data/biodata';

class BiodataMhs extends Component {
    state = {
        formdata: {
            nim: '',
            nama: '',
            prodi: '',
            dosen_wali: '',
            provinsi: '',
            kab: '',
            berkas: {
                ktp: '',
                kk: '',
                ijazah: '',
                ijazah_transfer: '',
                transkrip: '',
                skp: '',
            },
            foto_mhs: '0',
            kebutuhan_khusus_mhs: [],
            kebutuhan_khusus_ayah: [],
            kebutuhan_khusus_ibu: []
        },
        // dropdown
        provinsiList: biodataDropdown.provinsi,
        kotaList: [],
        kecamatanList: [],
        statusMhs: biodataDropdown.statusmhs,
        statusKelas: biodataDropdown.statuskelas,
        jalur: biodataDropdown.jalur,
        kategoriKelas: biodataDropdown.kategori_kelas,
        jalurTransfer: biodataDropdown.jalur_transfer,
        konsentrasi: biodataDropdown.konsentrasi,
        agama: biodataDropdown.agama,
        statusNikah: biodataDropdown.status_nikah,
        jenisTinggal: biodataDropdown.jenis_tinggal,
        transportasi: biodataDropdown.transportasi,
        pendidikan: biodataDropdown.pendidikan,
        pekerjaan: biodataDropdown.pekerjaan,
        penghasilan: biodataDropdown.penghasilan,
        jurusan: biodataDropdown.jurusan,
        jenjang_pendidikan: biodataDropdown.jenjangpendidikan_asal,
        // foto profile
        foto: '',
        linkFoto: "/no-image.jpg",
        isLoad: false,
        isLoad2: false,
        isWNA: false,
        akses: true,
        // params
        idVal: "",
        nimVal: ""
    }

    validateInput = (teks) => {
        const regex = /^[a-zA-Z0-9' ]+$/
        return regex.test(teks)
    };

    getKota = (provinsiId) => {
        const kota = biodataDropdown.kota[provinsiId] || [];
        this.setState({ kotaList: kota });
    }

    getKecamatan = (kotaName) => {
        const kota = this.state.kotaList.find(k => k.cname === kotaName);
        if (kota) {
            const kecamatan = biodataDropdown.kecamatan[kota.ic] || [];
            this.setState({ kecamatanList: kecamatan });
        }
    }

    getBiodata = () => {
        const nim = this.state.nimVal;
        const biodata = biodataMahasiswa[nim];

        if (biodata) {
            this.setState({
                formdata: { ...biodata }
            }, () => {
                if (this.state.formdata.provinsi) {
                    this.getKota(this.state.formdata.provinsi);
                }
                if (this.state.formdata.kab) {
                    setTimeout(() => this.getKecamatan(this.state.formdata.kab), 100);
                }
                if (this.state.formdata.kewarganegaraan === "WNA") {
                    this.setState({ isWNA: true });
                }
            });
        } else {
            // Default empty biodata for unknown NIM
            swal({
                icon: 'info',
                title: 'Data Demo',
                text: 'Ini adalah data demo. NIM yang tersedia: 20201001, 20201002, 20201003'
            });
        }
    }

    handleAkses = (e) => {
        this.setState({ akses: e.target.checked });
        swal({
            icon: 'success',
            title: 'Demo Mode',
            text: `Akses ${e.target.checked ? 'diaktifkan' : 'dinonaktifkan'} (simulasi)`,
            timer: 1500,
            buttons: false
        });
    }

    onChangeInput = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [e.target.name]: e.target.value
            }
        })
    }

    onChangeProv = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [e.target.name]: e.target.value,
                kab: '',
                kecamatan: ''
            }
        }, () => {
            if (this.state.formdata.provinsi) {
                this.getKota(this.state.formdata.provinsi);
            }
        })
    }

    onChangeKota = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                kab: e.target.value,
                kecamatan: ''
            }
        }, () => {
            this.getKecamatan(this.state.formdata.kab);
        })
    }

    onChangeWarga = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                kewarganegaraan: e.target.value
            },
            isWNA: e.target.value === "WNA"
        })
    }

    onChangeFoto = (event) => {
        if (event.target.files[0]) {
            const file = event.target.files[0];
            if (/(\.jpg|\.jpeg|\.png)$/i.test(file.name)) {
                document.getElementById('foto').src = URL.createObjectURL(file);
                swal({
                    icon: 'success',
                    title: 'Demo Mode',
                    text: 'Foto berhasil dipilih (simulasi upload)',
                    timer: 1500,
                    buttons: false
                });
            } else {
                swal({
                    icon: 'info',
                    title: 'Upload Gambar',
                    text: 'File harus berformat gambar (.jpg, .jpeg, .png)'
                });
            }
        }
    }

    submit = (e) => {
        e.preventDefault();
        this.setState({ isLoad2: true });

        setTimeout(() => {
            this.setState({ isLoad2: false });
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: 'Data berhasil disimpan (simulasi)',
                timer: 1500,
                buttons: false
            });
        }, 1000);
    }

    onChangeKhusus = (e) => {
        const { name, value, checked } = e.target;
        let fieldName = '';
        if (name === 'keb_ayah') fieldName = 'kebutuhan_khusus_ayah';
        else if (name === 'keb_ibu') fieldName = 'kebutuhan_khusus_ibu';
        else if (name === 'keb_mhs') fieldName = 'kebutuhan_khusus_mhs';

        if (fieldName) {
            let current = [...(this.state.formdata[fieldName] || [])];
            if (checked) {
                if (!current.includes(value)) current.push(value);
            } else {
                current = current.filter(x => x !== value);
            }
            this.setState({
                formdata: {
                    ...this.state.formdata,
                    [fieldName]: current
                }
            });
        }
    }

    handleUpload = (type) => {
        swal({
            icon: 'info',
            title: 'Demo Mode',
            text: 'Upload berkas tidak tersedia dalam mode demo'
        });
    }

    getDownload = (file, nim, type) => {
        swal({
            icon: 'info',
            title: 'Demo Mode',
            text: `Download ${type} tidak tersedia dalam mode demo`
        });
    }

    setParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            idVal: queryParams.get('id'),
            nimVal: queryParams.get('nim')
        }, () => {
            this.getBiodata();
        })
    }

    componentDidMount = () => {
        document.getElementById("biodataMenu").classList.add("active");
        $('.openTab').attr('checked', true);
        CollapseMenu();
        this.setParams();
    }

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Detail Biodata
                            </p>
                        </div>
                        <div className="col-12 col-xl-4 sm-md-none">
                            <div className="justify-content-end d-flex">
                                <div style={{ cursor: "pointer" }} title="expand/minimize" id="toogleMenu">
                                    <i className="fa fa-expand abu" id="iconQ"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" id="smoothMain">
                    <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                        <MenuDetail id={this.state.idVal} nim={this.state.nimVal} />
                    </div>
                    <div className="col-xl-9" id="kontenKiri">
                        <div className="row">
                            <div className="col-xl-4">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="outer">
                                            <img src="/no-image.jpg" className="fotoDetail" id="foto" alt="" />
                                            <div className="inner" title="ganti photo">
                                                <input className="inputfile" id="upload-photo" type="file" accept="image/*" name="foto" onChange={this.onChangeFoto} />
                                                <label className="ti-camera" />
                                            </div>
                                        </div>
                                    </div>
                                    <label className="switch mt-4 tengah" style={{ marginBottom: '-5px' }}>
                                        <input type="checkbox" id="togBtn" className="input-check" checked={this.state.akses} onChange={this.handleAkses} />
                                        <div className="slider round" />
                                    </label>
                                    {this.state.isLoad2 ? (
                                        <button className="btn btn-primary btn80 btnRounded30 mt-4 tengah" disabled>
                                            <i className="fa fa-spinner fa-spin" />&nbsp;&nbsp;updating data..
                                        </button>
                                    ) : (
                                        <button className="btn btn-primary btn80 btnRounded30 mt-4 tengah" onClick={this.submit}>
                                            <i className="fa fa-save" />&nbsp;&nbsp;update data
                                        </button>
                                    )}
                                    <Link className="btn btn-success btn80 btnRounded30 mt-2 tengah"
                                        to={{ pathname: `/printBiodata`, state: { dataPrint: this.state.formdata, provinsi: this.state.provinsiList, linkFoto: this.state.linkFoto } }}>
                                        <i className="fa fa-print" />&nbsp;&nbsp;cetak .pdf
                                    </Link>
                                    <BiodataMenu />
                                </div>
                            </div>
                            <div className="col-xl-8">
                                {/* Tab Profil Mahasiswa */}
                                <div className="tabsCon" id="tab1box">
                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck3" className="checkBox2 openTab" />
                                            <label className="tapbs-label2" htmlFor="chck3">Profil Mahasiswa</label>
                                            <div className="tapbs-content2">
                                                <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>NIM :</label>
                                                            <input type="text" name="nim" className="form-control form-biodata" disabled value={this.state.formdata.nim || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Nama Lengkap<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" name="nama" className="form-control form-biodata" value={this.state.formdata.nama || ''} onChange={this.onChangeInput} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Prodi :</label>
                                                            <input type="text" name="prodi" className="form-control form-biodata" disabled value={this.state.formdata.prodi || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Dosen Wali :</label>
                                                            <input type="text" name="dosen_wali" className="form-control form-biodata" disabled value={this.state.formdata.dosen_wali || ''} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck5" className="checkBox2" />
                                            <label className="tapbs-label2" htmlFor="chck5">Data Diri Mahasiswa</label>
                                            <div className="tapbs-content2">
                                                <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Jenis Kelamin<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <select name="gender" className="form-control form-biodata" onChange={this.onChangeInput} value={this.state.formdata.gender || ''}>
                                                                <option value="">- pilih -</option>
                                                                <option value="1">Laki-Laki</option>
                                                                <option value="2">Perempuan</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Tempat Lahir<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" className="form-control" name="tempat_lahir" onChange={this.onChangeInput} value={this.state.formdata.tempat_lahir || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Tanggal Lahir<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="date" className="form-control" name="tgl_lahir" onChange={this.onChangeInput} value={this.state.formdata.tgl_lahir || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Agama<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <select name="agama" className="form-control form-biodata" onChange={this.onChangeInput} value={this.state.formdata.agama || ''}>
                                                                <option value="">- pilih -</option>
                                                                {this.state.agama.map((list, i) => (<option key={i} value={list}>{list}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Kewarganegaraan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <select name="kewarganegaraan" onChange={this.onChangeWarga} value={this.state.formdata.kewarganegaraan || ''} className="form-control">
                                                                <option value="">- pilih -</option>
                                                                <option value="WNI">WNI</option>
                                                                <option value="WNA">WNA</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Status Pernikahan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <select name="status_nikah" className="form-control form-biodata" onChange={this.onChangeInput} value={this.state.formdata.status_nikah || ''}>
                                                                <option value="">- pilih -</option>
                                                                {this.state.statusNikah.map((list, i) => (<option key={i} value={list}>{list}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck6" className="checkBox2" />
                                            <label className="tapbs-label2" htmlFor="chck6">Alamat Mahasiswa</label>
                                            <div className="tapbs-content2">
                                                <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Provinsi<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <select name="provinsi" className="form-control form-biodata" onChange={this.onChangeProv} value={this.state.formdata.provinsi || ''}>
                                                                <option value="">- pilih -</option>
                                                                {this.state.provinsiList.map((list, i) => (<option key={i} value={list.i}>{list.pname}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Kabupaten/Kota<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <select name="kab" className="form-control form-biodata" onChange={this.onChangeKota} value={this.state.formdata.kab || ''}>
                                                                <option value="">- pilih -</option>
                                                                {this.state.kotaList.map((list, i) => (<option key={i} value={list.cname}>{list.cname}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Jalan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <textarea cols="30" rows="3" className="form-control" name="jalan" onChange={this.onChangeInput} value={this.state.formdata.jalan || ''}></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Kecamatan<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <select name="kecamatan" className="form-control form-biodata" onChange={this.onChangeInput} value={this.state.formdata.kecamatan || ''}>
                                                                <option value="">- pilih -</option>
                                                                {this.state.kecamatanList.map((list, i) => (<option key={i} value={list.dname}>{list.dname}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Kelurahan/Desa<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" className="form-control" name="kelurahan" onChange={this.onChangeInput} value={this.state.formdata.kelurahan || ''} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck7" className="checkBox2" />
                                            <label className="tapbs-label2" htmlFor="chck7">Informasi Kontak</label>
                                            <div className="tapbs-content2">
                                                <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Nomor WhatsApp<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" className="form-control" name="nowa" onChange={this.onChangeInput} value={this.state.formdata.nowa || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Email<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="email" className="form-control" name="email" onChange={this.onChangeInput} value={this.state.formdata.email || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>NIK<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" className="form-control" name="nik" onChange={this.onChangeInput} value={this.state.formdata.nik || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>NISN<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" className="form-control" name="nisn" onChange={this.onChangeInput} value={this.state.formdata.nisn || ''} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Tab Data Orang Tua */}
                                <div className="tabsCon" id="tab2box">
                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck8" className="checkBox2 openTab" />
                                            <label className="tapbs-label2" htmlFor="chck8">Data Ayah Mahasiswa</label>
                                            <div className="tapbs-content2">
                                                <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Nama Ayah<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" className="form-control" name="namaayah" onChange={this.onChangeInput} value={this.state.formdata.namaayah || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Pendidikan :</label>
                                                            <select name="pendidikan_ayah" onChange={this.onChangeInput} value={this.state.formdata.pendidikan_ayah || ''} className="form-control">
                                                                <option value="">- pilih -</option>
                                                                {this.state.pendidikan.map((list, i) => (<option key={i} value={list}>{list}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Pekerjaan :</label>
                                                            <select name="pekerjaan_ayah" className="form-control" onChange={this.onChangeInput} value={this.state.formdata.pekerjaan_ayah || ''}>
                                                                <option value="">- pilih -</option>
                                                                {this.state.pekerjaan.map((list, i) => (<option key={i} value={list}>{list}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>No. Telepon :</label>
                                                            <input type="text" name="notelp_ayah" className="form-control" onChange={this.onChangeInput} value={this.state.formdata.notelp_ayah || ''} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck9" className="checkBox2" />
                                            <label className="tapbs-label2" htmlFor="chck9">Data Ibu Mahasiswa</label>
                                            <div className="tapbs-content2">
                                                <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Nama Ibu<span style={{ color: '#cc2d34' }}>*</span> :</label>
                                                            <input type="text" className="form-control" name="nama_ibu" onChange={this.onChangeInput} value={this.state.formdata.nama_ibu || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Pendidikan :</label>
                                                            <select name="pendidikan_ibu" onChange={this.onChangeInput} value={this.state.formdata.pendidikan_ibu || ''} className="form-control">
                                                                <option value="">- pilih -</option>
                                                                {this.state.pendidikan.map((list, i) => (<option key={i} value={list}>{list}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label>Pekerjaan :</label>
                                                            <select name="pekerjaan_ibu" className="form-control" onChange={this.onChangeInput} value={this.state.formdata.pekerjaan_ibu || ''}>
                                                                <option value="">- pilih -</option>
                                                                {this.state.pekerjaan.map((list, i) => (<option key={i} value={list}>{list}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>No. Telepon :</label>
                                                            <input type="text" name="notelp_ibu" className="form-control" onChange={this.onChangeInput} value={this.state.formdata.notelp_ibu || ''} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Tab ABK */}
                                <div className="tabsCon" id="tab3box">
                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck11" className="checkBox2 openTab" />
                                            <label className="tapbs-label2" htmlFor="chck11">Kebutuhan Khusus Mahasiswa</label>
                                            <div className="tapbs-content2">
                                                <div style={{ padding: '5px 23px 30px 23px' }}>
                                                    <div className="table-responsive">
                                                        <table className="kebutuhanMhs" align="center" width="100%">
                                                            <tbody>
                                                                <tr>
                                                                    <td valign="top">
                                                                        {optionKebutuhan_1.map((v, index) => (
                                                                            <Fragment key={index}>
                                                                                <input type="checkbox" name="keb_mhs" value={v.value} onChange={this.onChangeKhusus} />&nbsp;{v.name}<br />
                                                                            </Fragment>
                                                                        ))}
                                                                    </td>
                                                                    <td valign="top">
                                                                        {optionKebutuhan_2.map((v, index) => (
                                                                            <Fragment key={index}>
                                                                                <input type="checkbox" name="keb_mhs" value={v.value} onChange={this.onChangeKhusus} />&nbsp;{v.name}<br />
                                                                            </Fragment>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Tab Riwayat Transfer */}
                                <div className="tabsCon" id="tab4box">
                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck14" className="checkBox2 openTab" />
                                            <label className="tapbs-label2" htmlFor="chck14">Riwayat Transfer</label>
                                            <div className="tapbs-content2">
                                                <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>NIM Asal :</label>
                                                            <input type="text" className="form-control" name="nim_asal_tf" onChange={this.onChangeInput} value={this.state.formdata.nim_asal_tf || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Nama Perguruan Tinggi Asal :</label>
                                                            <input type="text" className="form-control" name="nama_perguruan_tinggi_asal" onChange={this.onChangeInput} value={this.state.formdata.nama_perguruan_tinggi_asal || ''} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Program Studi Asal :</label>
                                                            <input type="text" className="form-control" name="jurusan_asal_tf" onChange={this.onChangeInput} value={this.state.formdata.jurusan_asal_tf || ''} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Tab Unggah Berkas */}
                                <div className="tabsCon" id="tab5box">
                                    <div className="TapS2">
                                        <div className="tapbs2">
                                            <input type="checkbox" id="chck15" className="checkBox2 openTab" />
                                            <label className="tapbs-label2" htmlFor="chck15">Unggah Berkas</label>
                                            <div className="tapbs-content2">
                                                <div className="row" style={{ padding: '10px 23px 10px 23px' }}>
                                                    <div className="col-md-12">
                                                        <div className="alert alert-info">
                                                            <strong>Demo Mode:</strong> Upload dan download berkas tidak tersedia dalam mode demo portfolio.
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>KTP :</label>
                                                            <button className="btn btn-info btn-block" type="button" onClick={() => this.handleUpload('ktp')}>
                                                                <i className="fa fa-file"></i>&nbsp;&nbsp;{this.state.formdata.berkas?.ktp || 'Belum ada file'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Kartu Keluarga :</label>
                                                            <button className="btn btn-info btn-block" type="button" onClick={() => this.handleUpload('kk')}>
                                                                <i className="fa fa-file"></i>&nbsp;&nbsp;{this.state.formdata.berkas?.kk || 'Belum ada file'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Ijazah :</label>
                                                            <button className="btn btn-info btn-block" type="button" onClick={() => this.handleUpload('ijazah')}>
                                                                <i className="fa fa-file"></i>&nbsp;&nbsp;{this.state.formdata.berkas?.ijazah || 'Belum ada file'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default BiodataMhs;
